import type { IconProps } from '../types/IconProps.ts';
export const BarcodeRead: IconProps = {
    name: 'BarcodeRead',
    children: [
        `<path d="M8.4 4H5a2 2 0 0 0-2 2v3.33M15.6 4H19a2 2 0 0 1 2 2v3.33M8.4 20H5a2 2 0 0 1-2-2v-3.33M15.6 20H19a2 2 0 0 0 2-2v-3.33M7 7v2m0 8v-5M8 7v2m0 8v-5M12 7v2m0 8v-5M16 7v2m0 8v-5M17 7v2m0 8v-5M5 12h14" />`,
    ]
};